import api from "@/lib/api";

const KEY = "ft_offline_queue";

function uid() {
  return typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : String(Date.now()) + Math.random().toString(16).slice(2);
}

export function getPending() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

function save(q) {
  localStorage.setItem(KEY, JSON.stringify(q));
  window.dispatchEvent(new CustomEvent("ft-queue-changed", { detail: q.length }));
}

export function pendingCount() { return getPending().length; }

export function addPending(item) {
  const q = getPending();
  q.push({ id: uid(), created: Date.now(), ...item });
  save(q);
}

// Flushes queued entries to the server. Guarded against concurrent runs
// (mount-time sync + an 'online' event could otherwise double-post).
let flushing = false;

export async function flushPending() {
  if (flushing) return 0;
  let q = getPending();
  if (!q.length) return 0;
  flushing = true;
  let synced = 0;
  try {
    for (const it of [...q]) {
      try {
        const url = it.type === "meter" ? "/meter-readings" : it.url;
        await api.post(url, it.payload);
        q = q.filter((x) => x.id !== it.id);
        save(q);
        synced += 1;
      } catch (e) {
        const status = e.response?.status;
        if (status === 400 || status === 422) {
          // Permanently invalid payload — drop so it can't wedge the queue.
          q = q.filter((x) => x.id !== it.id);
          save(q);
          continue;
        }
        // Network error or transient (401/408/429/5xx): keep and retry later.
        break;
      }
    }
  } finally {
    flushing = false;
  }
  return synced;
}
